import { c as _c } from "react/compiler-runtime";
import { cx } from 'class-variance-authority';
import type React from 'react';
import type { FieldValues } from 'react-hook-form';
import type { LabelTooltipProps } from '../internals/form-label';
import FormWrapper from '../internals/form-wrapper';
export type FormGroupProps<_TFieldValues extends FieldValues> = {
  label?: string | React.ReactNode;
  hint?: string | React.ReactNode;
  error?: string;
  errorPosition?: 'absolute' | 'relative';
  size?: 'default' | 'compact';
  disabled?: boolean;
  children: React.ReactNode;
  className?: string;
  fullWidth?: boolean;
  addon?: React.ReactNode;
  tooltip?: LabelTooltipProps;
  // Layout style for form children: children are spaced with gaps between them (default), or attached together without gaps/borders between adjacent inputs
  layout?: 'spaced' | 'attached';
  // Orientation of the form group: children are arranged horizontally (default) or vertically
  orientation?: 'vertical' | 'horizontal';
};
const attachedBase = '[&>*]:relative [&>*:focus-within]:z-10';
const attachedHorizontal = `gap-0 ${attachedBase} [&>*:not(:first-child)]:-ml-px [&>*:not(:last-child)_*]:rounded-r-none! [&>*:not(:first-child)_*]:rounded-l-none!`;
const attachedVertical = `gap-0 ${attachedBase} [&>*:not(:first-child)]:-mt-px [&>*:not(:last-child)_*]:rounded-b-none! [&>*:not(:first-child)_*]:rounded-t-none! [&>*:last-child_*]:rounded-b!`;
export default function FormGroup(t0) {
  const $ = _c(21);
  const {
    label,
    hint,
    error,
    errorPosition: t1,
    size: t2,
    disabled,
    children,
    className,
    fullWidth: t3,
    addon,
    tooltip,
    layout: t4,
    orientation: t5
  } = t0;
  const errorPosition = t1 === undefined ? "relative" : t1;
  const size = t2 === undefined ? "default" : t2;
  const fullWidth = t3 === undefined ? false : t3;
  const layout = t4 === undefined ? "spaced" : t4;
  const orientation = t5 === undefined ? "horizontal" : t5;
  const isAttached = layout === "attached";
  const isHorizontal = orientation === "horizontal";
  const t6 = isAttached && isHorizontal;
  const t7 = isAttached && !isHorizontal;
  const t8 = layout === "spaced";
  const t9 = !isHorizontal;
  let t10;
  if ($[0] !== isHorizontal || $[1] !== t6 || $[2] !== t7 || $[3] !== t8 || $[4] !== t9) {
    t10 = cx("flex", {
      [attachedHorizontal]: t6,
      [attachedVertical]: t7,
      "gap-2": t8,
      "flex-col": t9,
      "flex-row": isHorizontal
    });
    $[0] = isHorizontal;
    $[1] = t6;
    $[2] = t7;
    $[3] = t8;
    $[4] = t9;
    $[5] = t10;
  } else {
    t10 = $[5];
  }
  let t11;
  if ($[6] !== children || $[7] !== t10) {
    t11 = <div className={t10}>{children}</div>;
    $[6] = children;
    $[7] = t10;
    $[8] = t11;
  } else {
    t11 = $[8];
  }
  let t12;
  if ($[9] !== addon || $[10] !== className || $[11] !== disabled || $[12] !== error || $[13] !== errorPosition || $[14] !== fullWidth || $[15] !== hint || $[16] !== label || $[17] !== size || $[18] !== t11 || $[19] !== tooltip) {
    t12 = <FormWrapper error={error} label={label} errorPosition={errorPosition} size={size} hint={hint} addon={addon} tooltip={tooltip} fullWidth={fullWidth} disabled={disabled} className={className}>{t11}</FormWrapper>;
    $[9] = addon;
    $[10] = className;
    $[11] = disabled;
    $[12] = error;
    $[13] = errorPosition;
    $[14] = fullWidth;
    $[15] = hint;
    $[16] = label;
    $[17] = size;
    $[18] = t11;
    $[19] = tooltip;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  return t12;
}